import { css } from "styled-components";

export const fieldsetReset = () => css`
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
`;
